import React from 'react';
import { Flex, Box, xcss, Text } from '@atlaskit/primitives';
import ErrorImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/generic-error';
import EmptyImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/search-error';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const FALLBACK_TYPE = {
	ERROR: 'ERROR',
	NOTFOUND: 'NOTFOUND',
} as const;

type FallbackType = {
	type: (typeof FALLBACK_TYPE)[keyof typeof FALLBACK_TYPE];
};

const FALLBACK_ERROR_IMAGE_SIZE = 84;

export const Fallback = ({ type }: FallbackType) => {
	const { formatMessage } = useIntl();

	if (type === FALLBACK_TYPE.ERROR) {
		return (
			<Flex direction="column" justifyContent="center" alignItems="center" xcss={wrapperStyles}>
				<ErrorImage alt={formatMessage(messages.errorTitle)} width={FALLBACK_ERROR_IMAGE_SIZE} />
				<Box xcss={textWrapperStyles}>
					<Text color="color.text.accent.gray" size="UNSAFE_small" weight="bold">
						{formatMessage(messages.errorMessage)}
					</Text>
				</Box>
			</Flex>
		);
	}
	return (
		<Flex direction="column" justifyContent="center" alignItems="center" xcss={wrapperStyles}>
			<EmptyImage alt={formatMessage(messages.emptyTitle)} width={FALLBACK_ERROR_IMAGE_SIZE} />
			<Box xcss={textWrapperStyles}>
				<Text color="color.text.accent.gray" size="UNSAFE_small" weight="bold">
					{formatMessage(messages.emptyMessage)}
				</Text>
			</Box>
		</Flex>
	);
};

const wrapperStyles = xcss({
	padding: 'space.300',
	marginBottom: 'space.200',
	textAlign: 'center',
	color: 'color.text.accent.gray',
});

const textWrapperStyles = xcss({
	margin: 'space.300',
});
